<ng-template #loading>
  <boma-progress-spinner [fullScreen]="true"></boma-progress-spinner>
</ng-template>

<div
  *ngIf="user$ | async as user; else loading"
  class="grid justify-content-center"
>
  <div class="card">
    <div class="col-12 lg:col-10 xl:col-8">
      <div class="grid justify-content-center">
        <div class="col-10 md:col-8 mb-3 pl-0">
          <h3>{{ user.firstName }} {{ user.surname }}</h3>
          <p>
            This view contains all the users information of which ogranisations
            the user belongs to as well as their permissions.
          </p>
        </div>

        <div class="col-2 md:col-4 text-right"></div>
      </div>
      <h3>Contact Information</h3>
      <div class="grid box-section hover-card p-5">
        <div class="col-12 pl-0">
          <div class="grid justify-content-center">
            <div class="col-12 md:col-6">
              <p-table [value]="[[]]" styleClass="p-datatable-gridlines">
                <ng-template pTemplate="body">
                  <tr>
                    <td class="m-0" style="width: 150px">Firstname</td>
                    <td class="m-0">
                      {{ user.firstName }}
                    </td>
                  </tr>
                  <tr>
                    <td class="m-0" style="width: 150px">Lastname</td>
                    <td class="m-0">
                      {{ user.surname }}
                    </td>
                  </tr>
                  <tr>
                    <td class="m-0" style="width: 150px">Phone Number</td>
                    <td class="m-0">
                      {{ user.phoneNumber }}
                    </td>
                  </tr>
                  <tr>
                    <td class="m-0" style="width: 150px">Email</td>
                    <td class="m-0">
                      {{ user.email }}
                    </td>
                  </tr>
                  <tr>
                    <td class="m-0" style="width: 150px">UserId</td>
                    <td class="m-0">
                      {{ user.id }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="user.roles.length > 0">
        <h3>Organisations</h3>
        <!-- TODO FIX API BUG Issue with the permissions being aggregated it seems on entity level  Remove this comment once resolved-->

        <div class="grid box-section hover-card p-5">
          <div *ngFor="let entity of user.roles" class="col-12 pl-0">
            <p-panel
              [collapsed]="true"
              [header]="entity.entityName"
              [toggleable]="entity.entityRoles.roles.length > 0"
            >
              <div
                *ngIf="entity.entityRoles.roles.length > 0"
                class="col-12 md:col-6"
              >
                <p-table
                  [value]="entity.entityRoles.roles"
                  styleClass="p-datatable-gridlines"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Role/Permission</th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template let-role pTemplate="body">
                    <tr>
                      <td class="m-0">
                        {{ role.name }}
                      </td>
                      <td>
                        <button
                          (click)="removeRoleFromUser(role.id)"
                          class="p-button-rounded p-button-warning"
                          icon="pi pi-trash"
                          pButton
                          type="button"
                        ></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </p-panel>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-container *ngIf="roles">
  <p-dialog
    [(visible)]="displayAddRoleToUserDialog"
    [modal]="true"
    [style]="{ width: '450px' }"
    header="Add Role"
  >
    <label> Role: </label>
    <p-dropdown
      [(ngModel)]="roleToAdd"
      [options]="roles"
      appendTo="body"
      inputId="role"
      optionLabel="name"
      placeholder="Select"
    ></p-dropdown>

    <ng-template pTemplate="footer">
      <button
        (click)="this.displayAddRoleToUserDialog = false"
        class="p-button-text"
        icon="pi pi-times"
        label="Cancel"
        pButton
        pRipple
      ></button>
      <button
        (click)="addRoleToUser()"
        class="p-button-text"
        icon="pi pi-check"
        label="Save"
        pButton
        pRipple
      ></button>
    </ng-template>
  </p-dialog>
</ng-container>
